import { useNavigate } from "react-router-dom";
import T from "../../../../components/Typography";
import ErrorPage from "../../../../components/ErrorPage";
import Loader from "../../../../components/Loader";
import useGetAccount from "../../../../hooks/queries/employee/useGetAccount";
import {
  Header,
  AccountChart,
  YourContribution,
  MatchProgress,
  RecentActivity,
  ReferralCard,
  YourDebitCard,
  ActivateCard,
  FAQs,
} from "./components";
import Page from "../../../../components/Layout/Page";
import PageContent from "../../../../components/Layout/PageContent";
import Button from "../../../../components/Button";
import { formatCurrency } from "../../../../helpers/currency";
import { useIsMobile } from "../../../../helpers/ui";
import { colors } from "../../../../styles";
import {
  employeeAccounInviteCoworkersPath,
  employeeTransfersPath,
} from "../../../../routes/paths";

export const getGreeting = () => {
  const today = new Date();
  const curHr = today.getHours();

  if (curHr < 12) {
    return "Good morning";
  }
  if (curHr < 18) {
    return "Good afternoon";
  }
  return "Good evening";
};

const Account = () => {
  const { data, status } = useGetAccount();
  const isMobile = useIsMobile();
  const navigate = useNavigate();

  if (status === "loading") return <Loader />;
  if (status === "error") return <ErrorPage />;

  const balance = formatCurrency(
    data.challenger_saving.account_available_balance,
    2
  );
  const referralBonus = formatCurrency(
    data.employer.coworker_referral_program.referral_amount || "0"
  );

  const headerBtnWidth = isMobile ? 140 : 249;
  return (
    <Page>
      <Header>
        <div>
          <T variant="headingSm">{`${getGreeting()}, ${
            data.user.first_name
          }`}</T>
          <T variant="headingLg">{balance}</T>
          <T variant="mdReg">Your Balance</T>
          <div>
            <Button
              sx={{
                position: "absolute",
                bottom: -18,
                width: `${headerBtnWidth}px`,
              }}
              onClick={() => navigate(employeeTransfersPath)}
            >
              Add / Send
            </Button>
            {!isMobile && (
              <Button
                btntype="secondary"
                sx={{
                  position: "absolute",
                  bottom: -18,
                  left: `${headerBtnWidth + 40}px`,
                  width: `${headerBtnWidth}px`,
                }}
                onClick={() => navigate(employeeAccounInviteCoworkersPath)}
              >
                <div>
                  <T variant="mdMed" display={"inline"}>
                    Invite Coworkers,{" "}
                  </T>
                  <T
                    variant="mdMed"
                    display={"inline"}
                    color={colors.light_purple}
                  >
                    Earn {referralBonus}
                  </T>
                </div>
              </Button>
            )}
          </div>
        </div>
      </Header>
      <PageContent customStyles={{ maxWidth: "1500px" }}>
        <>
          <AccountChart data={data} balance={balance} />
          <div
            className={`flex gap-16`}
            style={{
              flexDirection: isMobile ? "column" : "row",
              paddingBottom: 32,
            }}
          >
            <div className="flex-1">
              <ActivateCard data={data.challenger_saving.debit_card} />
              <YourContribution data={data} />
              <MatchProgress data={data.challenger_saving.sponsored_savings} />
              {isMobile && (
                <RecentActivity
                  data={data.challenger_saving.recent_transactions}
                />
              )}
              {isMobile && <ReferralCard data={data.employer} />}
              <YourDebitCard data={data.challenger_saving.debit_card} />
            </div>
            <div className="flex-1">
              {!isMobile && (
                <RecentActivity
                  data={data.challenger_saving.recent_transactions}
                />
              )}

              <FAQs data={data.challenger_saving.debit_card} />
            </div>
          </div>
        </>
      </PageContent>
    </Page>
  );
};

export default Account;
